// extracted by mini-css-extract-plugin
module.exports = {"notes":"BookingEngineConfigDetailsCard_notes__34eIJ","notesText":"BookingEngineConfigDetailsCard_notesText__3srPR"};